module.exports = __webpack_public_path__ + "img/rank.69134f2a.png";